import { HttpClient } from '@angular/common/http';
import { Injectable, signal, Type } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, of } from 'rxjs';

import {
  AccessibilitySettings,
  environment,
} from 'src/index';
import {
  ViewerContentService,
  ViewerPostMessageService
} from 'src/index/services.index';

@Injectable({
  providedIn: 'root'
})
export class ViewerService {
  fullscreenDynamicComponent$ = new BehaviorSubject<Type<any> | undefined>(undefined);
  $accessibilitySettings = signal<AccessibilitySettings>({ background: 'white', size: 'normal', family: 'sans-serif', line: 'normal' });

  constructor(
    public httpClient: HttpClient,
    public viewerContentService: ViewerContentService,
    public viewerPostMessageService: ViewerPostMessageService,
  ) {
  }

  getPublication(pubId: string): Observable<any | undefined> {
    if (environment.getPublication) {
      return this.httpClient.get<any>(environment.getPublication.replace(':publicationId', pubId)).pipe(
        catchError(() => of(undefined)),
      );
    }
    return of(undefined);
  }

  getContent(pubId: string, contentId: string): Observable<any | undefined> {
    if (environment.getContent) {
      return this.httpClient.get<any>(
        environment.getContent.replace(':contentId', contentId).replace(':publicationId', pubId)
      ).pipe(
        catchError(() => of(undefined)),
        map(data => this.viewerContentService.handleData(data))
      );
    }
    return of(undefined);
  }

  toggleCutMode() {
    this.viewerPostMessageService.postMessage('toggleCut', undefined);
  }
}
